import React, {useContext} from "react";
import {useHistory} from "react-router-dom";
import {TabsContext} from "../../../context/TabsContext";
import {TranslateContext} from "../../../context/TranslateContext";
import {AuthContext} from "../../../context/AuthContext";
import CommentoView from "./CommentoView";

export default function CommentoController({commento, addRouteBase, deleteCallback, parentTab = '', parentPaginaTab = ''}) {

    const history = useHistory();
    const {updateTabKey} = useContext(TabsContext);
    const {translate} = useContext(TranslateContext);
    const {user} = useContext(AuthContext);

    let usr = {
        nome: commento.nome_ins,
        cognome: commento.cognome_ins
    };

    function isUsrLoggato() {
        return commento && commento.id_usr_ins === user.id_utente;
    }

    function onClickDettaglio() {
        updateTabKey(parentPaginaTab, parentTab);
        history.push(addRouteBase + commento.id_commento_kpi);
    }

    return (
        <CommentoView
            isUsrLoggato={isUsrLoggato}
            commento={commento}
            translate={translate}
            deleteCallback={deleteCallback}
            usr={usr}
            onClickDettaglio={onClickDettaglio}
        />
    );
}
